export const INIT_PROCESS = 'process/init';
export const UPDATE_BLOTTER_SETTINGS = 'blotterSettings/update';
export const UPDATE_BLOTTER_SETTINGS_SUCCESS = 'blotterSettings/update/success';
export const UPDATE_BLOTTER_SETTINGS_ERROR = 'blotterSettings/update/error';
export const HOME_PAGE_URL = '/';
